import { createDayGridScenario } from '../actions/dayGridActions';
import getStore from '../store';
import { mutator } from 'satcheljs';

mutator(createDayGridScenario, ({ scenario }) => {
    let scenarios = getStore().scenarios;
    scenarios.set(scenario, { schedulingGridViewState: null });
});
